"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWarehousePathPoint = exports.warehousePathPointSchema = void 0;
const yup = require("yup");
exports.warehousePathPointSchema = yup.object().shape({
    lat: yup.number().required(),
    lng: yup.number().required(),
});
function isWarehousePathPoint(obj) {
    return exports.warehousePathPointSchema.isValidSync(obj);
}
exports.isWarehousePathPoint = isWarehousePathPoint;
//# sourceMappingURL=WarehousePathPoint.js.map